var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8227 8.19789C19.9417 8.86907 20.001 9.5491 20 10.2303C20 13.2727 18.8906 15.8451 16.9599 17.5863H16.9625C15.2742 19.115 12.9533 20 10.2015 20C7.49587 20 4.90109 18.9465 2.98794 17.0712C1.0748 15.1959 0 12.6524 0 10.0003C0 7.34825 1.0748 4.8048 2.98794 2.9295C4.90109 1.05419 7.49587 0.000659837 10.2015 0.000659837C12.7339 -0.0284121 15.1796 0.904171 17.0263 2.60307L14.1137 5.45798C13.0609 4.47423 11.6558 3.93552 10.2015 3.95803C7.54016 3.95803 5.27926 5.71797 4.47335 8.08789C4.04604 9.32973 4.04604 10.6747 4.47335 11.9165H4.47717C5.28691 14.2827 7.54399 16.0426 10.2053 16.0426C11.5799 16.0426 12.7608 15.6976 13.6764 15.0877H13.6725C14.2042 14.7424 14.6589 14.2952 15.0094 13.7729C15.3598 13.2507 15.5987 12.6642 15.7115 12.049H10.2015V8.19914H19.8227V8.19789Z",
    fill: "#00C17E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.03c1e389eee1900889c716c97b4be505.svg";
export { ForwardRef as ReactComponent };